export default __webpack_public_path__ + "static/media/SAS0050.34I-34120_-18341_50.8e197ff4.jpg";